import dynamic from 'next/dynamic'
import { DemographicsIcon } from 'src/components/insights/icons/demographics'
import { InsightBuilderWidget } from 'src/types/insight-builder'
import preview from 'src/assets/images/widgets-previews/labor-force.png'

const DemographicsLaborForce = dynamic(() => import('src/components/insights/demographics/cards/labor-force'), {
  ssr: false,
})

export const DemographicsLaborForceWidget: InsightBuilderWidget = {
  id: 'labor-force',
  name: 'Labor Force',
  type: 'Demographics',
  icon: DemographicsIcon,
  component: DemographicsLaborForce,
  supportedResultTypes: ['alphamap-location'],
  preview,
}
